export const STUDENT_ACTIVITIES = {
  events: [{ id: 1 }, { id: 2 }, { id: 3 }],
  leaderBoard: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
  tableHead: ['Assignments', 'Assessments', 'Completed'],
  tableContent: [
    {
      head: {
        headText: 'Maths Algebra Equation Assignment',
        headSmall: '4th January, 2023',
      },
      grade: '7/10',
      status: 'Completed',
    },
    {
      head: {
        headText: 'English Assignment on Pronuns',
        headSmall: '4th January, 2023',
      },
      grade: '7/10',
      status: 'Pending',
    },
    {
      head: {
        headText: 'Physics Pendulum Assignment',
        headSmall: '4th January, 2023',
      },
      grade: '7/10',
      status: 'Not done',
    },
    {
      head: {
        headText: 'Periodic Table Memorization',
        headSmall: '4th January, 2023',
      },
      grade: '7/10',
      status: 'Completed',
    },
  ],
}
